/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Box, Grid } from '@mui/material';
import { OutlinedButton } from '../index';

const style = {
  mr: 3,
  fontWeight: 600,
};

const boxStyle = {
  mx: 0,
  my: 1,
  px: 3,
  py: 2,
};

export const AccountManagement = () => {
  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={boxStyle}>
        <Grid container spacing={2}>
          <Grid item xs={4} style={{ display: 'flex' }}>
            <OutlinedButton
              href="https://forms.office.com/r/uyEX0sDfiD"
              target="_blank"
              style={{ flex: 1, height: 1, textAlign: 'center' }}
              btnTitle={'OT Application'}
            />
          </Grid>

          <Grid item xs={4} style={{ display: 'flex' }}>
            <OutlinedButton
              href="https://forms.office.com/r/CVLLjC1zff"
              target="_blank"
              style={{ flex: 1, height: 1, textAlign: 'center' }}
              btnTitle={'Leave Application'}
            />
          </Grid>

          <Grid item xs={4} style={{ display: 'flex' }}>
            <OutlinedButton
              href="https://ibridgeph.sharepoint.com/:x:/s/iBPCommon/EWMsaEe9bXpIr8COpbqMnBABvmMlvdXulCaL3vWLWLOekA?e=eIuRfv"
              target="_blank"
              style={{ flex: 1, height: 1, textAlign: 'center' }}
              btnTitle={'Hybrid Setup Application'}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
